import React from "react";
import "./SimpleTextInput.css";

class SimpleTextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="simple-text-input">
        <label htmlFor={this.props.id}>{this.props.label}</label>
        <input
          style={{ cursor: "default" }}
          type={this.props.type}
          id={this.props.id}
          placeholder={this.props.placeholder}
          name={this.props.id + "simple-text-input"}
          spellCheck={false}
          required={this.props.required}
          readOnly={true}
        />
        <div className="simple-text-input-buttons-container">
          <div
            className="simple-text-input-edit"
            onClick={this.props.handlePasswordButtonOnClick}
          >
            <React.Fragment>Change password</React.Fragment>
          </div>
        </div>
      </div>
    );
  }
}

export default SimpleTextInput;
